import { useCart } from "@/lib/cart";
import { useNavigate } from "react-router-dom";
import { X, Trash2, Minus, Plus } from "lucide-react";
import { fileUrl } from "@/lib/api";

export default function CartDrawer() {
    const { items, open, setOpen, setQty, remove, subtotal } = useCart();
    const navigate = useNavigate();

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50" data-testid="cart-drawer">
            <div className="absolute inset-0 bg-black/70" onClick={() => setOpen(false)} />
            <div className="absolute right-0 top-0 bottom-0 w-full sm:w-[420px] bg-[#121216] border-l border-white/10 flex flex-col">
                <div className="flex items-center justify-between p-5 border-b border-white/10">
                    <div className="font-serif-luxe text-xl tracking-wider chrome-text">Votre Panier</div>
                    <button data-testid="cart-close-btn" onClick={() => setOpen(false)} aria-label="Fermer">
                        <X className="w-6 h-6 text-slate-300" />
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto p-5 space-y-4">
                    {items.length === 0 && (
                        <div data-testid="cart-empty" className="text-center text-slate-400 py-16">
                            Votre panier est vide.
                        </div>
                    )}
                    {items.map((it) => (
                        <div key={`${it.product_id}-${it.variant_id}-${it.finition || ""}`} data-testid={`cart-item-${it.variant_id}`} className="glass-card rounded-xl p-3 flex gap-3">
                            <img src={fileUrl(it.image)} alt={it.name} className="w-20 h-20 object-cover rounded-lg bg-black/40" />
                            <div className="flex-1 min-w-0">
                                <div className="text-sm font-medium text-slate-100 truncate">{it.name}</div>
                                <div className="text-xs text-slate-400 mt-0.5">{it.variant_label}</div>
                                <div className="flex items-center justify-between mt-2">
                                    <div className="flex items-center gap-2">
                                        <button
                                            data-testid={`cart-item-minus-${it.variant_id}`}
                                            onClick={() => setQty(it.product_id, it.variant_id, it.quantity - 1, it.finition || "")}
                                            className="p-1 border border-white/10 rounded"
                                        ><Minus className="w-3 h-3" /></button>
                                        <span data-testid={`cart-item-qty-${it.variant_id}`} className="text-sm w-6 text-center">{it.quantity}</span>
                                        <button
                                            data-testid={`cart-item-plus-${it.variant_id}`}
                                            onClick={() => setQty(it.product_id, it.variant_id, it.quantity + 1, it.finition || "")}
                                            className="p-1 border border-white/10 rounded"
                                        ><Plus className="w-3 h-3" /></button>
                                    </div>
                                    <div className="text-sm font-semibold text-slate-100">{(it.price_cad * it.quantity).toFixed(2)} $</div>
                                </div>
                            </div>
                            <button
                                data-testid={`cart-item-remove-${it.variant_id}`}
                                onClick={() => remove(it.product_id, it.variant_id, it.finition || "")}
                                className="self-start p-1 text-slate-500 hover:text-red-400 transition-colors"
                                aria-label="Retirer"
                            ><Trash2 className="w-4 h-4" /></button>
                        </div>
                    ))}
                </div>

                {items.length > 0 && (
                    <div className="p-5 border-t border-white/10 space-y-4">
                        {subtotal < 500 && (
                            <div data-testid="cart-free-shipping-hint" className="text-[11px] text-slate-400 tracking-wider uppercase text-center">
                                Plus que {(500 - subtotal).toFixed(2)} $ pour la livraison gratuite
                            </div>
                        )}
                        {subtotal >= 500 && (
                            <div data-testid="cart-free-shipping-unlocked" className="text-[11px] text-slate-200 tracking-wider uppercase text-center">
                                Livraison offerte
                            </div>
                        )}
                        <div className="flex justify-between text-sm">
                            <span className="text-slate-400">Sous-total</span>
                            <span data-testid="cart-subtotal" className="font-semibold">{subtotal.toFixed(2)} $ CAD</span>
                        </div>
                        <button
                            data-testid="go-to-checkout-btn"
                            className="btn-primary w-full"
                            onClick={() => { setOpen(false); navigate("/commande"); }}
                        >
                            Passer commande
                        </button>
                        <button
                            data-testid="go-to-cart-btn"
                            className="btn-ghost w-full"
                            onClick={() => { setOpen(false); navigate("/panier"); }}
                        >
                            Voir le panier
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
